import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ESIMWelcomeModal from '../../../copms/Modal/ESIMWelcomeModal';
import ESIMRulesModal from '../../../copms/Modal/ESIMRulesModal';
import { esimApi } from './esimApi';
import { customerType } from '../../../helpers/customer';
import { statusCodes } from '../../../helpers/statusCodes';

class ESIM extends Component {
    state = {
        showWelcomeModal: false,
        showRulesModal: false,
        welcomeTermsAccepted: false,
        welcomeTermsLoading: false,
        rulesText: '',
        title: '',
        termsVersion: '',
        termsLanguageCode: 'AZ',
        termsAccepted: false,
        activeTab: 'COUNTRY',
        searchValue: '',
        popularCountries: [],
        countryPackages: [],
        regionalPackages: [],
        globalPackages: [],
        destinations: []
    }

    tabs = [
        { key: 'COUNTRY', label: 'Ölkələr' },
        { key: 'REGION', label: 'Regional' },
        { key: 'GLOBAL', label: 'Global' }
    ]

    getFirstVisitKey = () => {
        const userId = localStorage.getItem('compId') || localStorage.getItem('custId') || 'guest';
        return `esimFirstVisitModalShown_${userId}`;
    }

    closeWelcomeModal = () => {
        this.setState({ showWelcomeModal: false, welcomeTermsAccepted: false });
    }

    setTransparentLoading = (value) => {
        if (this.props.updateAppState) {
            this.props.updateAppState('isLoadingTransparentBackground', value);
        }
    }

    confirmWelcomeModal = async () => {
        if (!this.state.welcomeTermsAccepted) {
            return;
        }

        this.setState({ welcomeTermsLoading: true });

        try {
            const languageCode = String(this.state.termsLanguageCode || localStorage.getItem('i18nextLng') || 'AZ').toUpperCase();

            await esimApi.acceptTerms({
                termsVersion: this.state.termsVersion || 'v1',
                languageCode
            });
            this.setState({ showWelcomeModal: false, termsAccepted: true, welcomeTermsLoading: false });
        } catch (error) {
            this.setState({ welcomeTermsLoading: false });
        }
    }

    toggleTerms = () => {
        this.setState((prevState) => ({
            welcomeTermsAccepted: !prevState.welcomeTermsAccepted
        }));
    }

    setActiveTab = (activeTab) => {
        if (activeTab === this.state.activeTab) {
            return;
        }

        this.setState({ activeTab }, () => {
            this.loadDestinations(activeTab);
        });
    }

    updateSearch = (event) => {
        this.setState({ searchValue: event.target.value });
    }

    getFilteredCountries = () => {
        const { countryPackages, popularCountries, searchValue } = this.state;
        const popularCodes = popularCountries.map((country) => country.code);
        const nonPopularCountries = countryPackages.filter((country) => !popularCodes.includes(country.code));

        if (!searchValue.trim()) {
            return nonPopularCountries;
        }

        return nonPopularCountries.filter((country) => country.name.toLowerCase().includes(searchValue.toLowerCase()));
    }

    getFilteredRegionalPackages = () => {
        const { regionalPackages, searchValue } = this.state;

        if (!searchValue.trim()) {
            return regionalPackages;
        }

        return regionalPackages.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase()));
    }

    getFilteredGlobalPackages = () => {
        const { globalPackages, searchValue } = this.state;

        if (!searchValue.trim()) {
            return globalPackages;
        }

        return globalPackages.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase()));
    }

    openCountryDetails = (country) => {
        const countryKey = typeof country === 'object' ? (country.code || country.name) : country;
        this.props.history.push(`/dashboard/services/e-sim/details/${encodeURIComponent(countryKey)}`);
    }

    openOrderPage = (countryName, plan) => {
        this.props.history.push({
            pathname: `/dashboard/services/e-sim/order/${encodeURIComponent(countryName)}/${plan.id}`,
            state: {
                selectedCountry: countryName,
                selectedPlan: plan
            }
        });
    }

    renderChevron = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M5.96655 2.72003L10.3132 7.0667C10.8266 7.58003 10.8266 8.42003 10.3132 8.93336L5.96655 13.28" stroke="#64748B" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }

    componentDidMount = () => {
        const bankCustomerType = Number(localStorage.getItem("bankCustomerType"));
        if (bankCustomerType === customerType.NON_CUSTOMER) {
            this.props.alertState(
                true,
                'error',
                this.props.t('an error occurred'),
                this.props.t(statusCodes.ACCESS_DENIED_OPERATION),
                '/dashboard'
            );
            return;
        }
        this.loadTermsData();
        this.loadDestinations('COUNTRY');
    }

    loadTermsData = async () => {
        try {
            const [termsStatusResponse, termsResponse] = await Promise.all([
                esimApi.getTermsStatus(),
                esimApi.getTerms()
            ]);

            const accepted = Boolean(termsStatusResponse.data.accepted);

            this.setState({
                showWelcomeModal: !accepted,
                termsAccepted: accepted,
                rulesText: termsResponse.data.content,
                title: termsResponse.data.title,
                termsVersion: termsResponse?.data?.termsVersion || '',
                termsLanguageCode: String(termsResponse?.data?.languageCode || localStorage.getItem('i18nextLng') || 'AZ').toUpperCase()
            });
        } catch (error) {
            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(error?.response?.status?.statusCode), '/dashboard/home');
        }
    }

    // getTermsText = (response) => {
    //     if (!response) {
    //         return '';
    //     }

    //     if (typeof response === 'string') {
    //         return response;
    //     }

    //     if (Array.isArray(response)) {
    //         return response.join('\n\n');
    //     }

    //     return response.data.content || '';
    // }

    formatPriceFromCents = (cents) => {
        const value = Number(cents);

        if (!Number.isFinite(value) || value <= 0) {
            return '';
        }

        return `${(value / 100).toFixed(2)} AZN`;
    }

    loadDestinations = async (tabKey = this.state.activeTab) => {
        const { countryPackages, regionalPackages, globalPackages } = this.state;
        const hasCachedData =
            (tabKey === 'COUNTRY' && countryPackages.length > 0)
            || (tabKey === 'REGION' && regionalPackages.length > 0)
            || (tabKey === 'GLOBAL' && globalPackages.length > 0);

        if (hasCachedData) {
            return;
        }

        this.setTransparentLoading(true);

        try {
            const response = await esimApi.getDestinations(tabKey);
            const tabDestinations = response?.data || [];

            if (tabKey === 'COUNTRY') {
                const popularCountries = tabDestinations
                    .slice(0, 6)
                    .map((item, index) => ({
                        id: item.code || index + 1,
                        code: item.code,
                        name: item.name,
                        flag: item.flagUrl || '🌍',
                        price: this.formatPriceFromCents(item.startingPriceCents)
                    }));

                const mappedCountryPackages = tabDestinations
                    .map((item, index) => ({
                        id: item.code || index + 1,
                        code: item.code,
                        name: item.name,
                        flag: item.flagUrl || '🌍',
                        price: this.formatPriceFromCents(item.startingPriceCents)
                    }));

                this.setState({
                    popularCountries: popularCountries.length ? popularCountries : this.state.popularCountries,
                    countryPackages: mappedCountryPackages.length ? mappedCountryPackages : this.state.countryPackages,
                    destinations: tabDestinations,
                });

                return;
            }

            if (tabKey === 'REGION') {
                const mappedRegionalPackages = tabDestinations
                    .map((item, index) => ({
                        id: item.code || index + 1,
                        code: item.code,
                        name: item.name,
                        icon: item.flagUrl || '🌍',
                        countriesCount: item.countriesCount ? `${item.countriesCount} ölkə` : '—',
                        price: this.formatPriceFromCents(item.startingPriceCents)
                    }));

                this.setState({
                    regionalPackages: mappedRegionalPackages.length ? mappedRegionalPackages : this.state.regionalPackages,
                    destinations: tabDestinations,
                });

                return;
            }

            const mappedGlobalPackages = tabDestinations
                .map((item, index) => ({
                    id: item.code || index + 1,
                    code: item.code,
                    name: item.name,
                    icon: item.flagUrl || '🌐',
                    countriesCount: item.countriesCount ? `${item.countriesCount} ölkə` : '—',
                    price: this.formatPriceFromCents(item.startingPriceCents)
                }));

            this.setState({
                globalPackages: mappedGlobalPackages.length ? mappedGlobalPackages : this.state.globalPackages,
                destinations: tabDestinations
            });
        } catch (error) {
            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(100), '/dashboard/home');
        } finally {
            this.setTransparentLoading(false);
        }
    }

    render() {
        const { showWelcomeModal, welcomeTermsAccepted, showRulesModal, activeTab, searchValue, popularCountries, rulesText, title, welcomeTermsLoading } = this.state;
        const { t } = this.props;
        const filteredCountries = this.getFilteredCountries();
        const filteredRegionalPackages = this.getFilteredRegionalPackages();
        const filteredGlobalPackages = this.getFilteredGlobalPackages();
        return (
            <>
                <ESIMWelcomeModal
                    open={showWelcomeModal}
                    onClose={() => this.props.history.push('/dashboard/home')}
                    onConfirm={this.confirmWelcomeModal}
                    onToggleTerms={this.toggleTerms}
                    termsAccepted={welcomeTermsAccepted}
                    onOpenRules={() => this.setState({ showRulesModal: true })}
                    onConfirmLoading={welcomeTermsLoading}
                />
                <ESIMRulesModal
                    open={showRulesModal}
                    onClose={() => this.setState({ showRulesModal: false })}
                    content={rulesText}
                    title={title}
                />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIM')}</h2>
                    </div>
                    <div>
                        <button onClick={() => this.props.history.push('/dashboard/services/e-sim/my-esims')} className="dashboard-header-route-button">{t('eSIMlərim')}</button>
                    </div>
                </div>
                <div className="dashboard-account-body">
                    <div className="m-3" style={{ marginTop: '1px' }}>
                        <div className="dashboard-esim-destination">
                            <h3 className="dashboard-esim-destination-title">{t('Səyahət istiqamətləri')}</h3>

                            <div className="dashboard-esim-destination-filters">
                                <div className="dashboard-esim-destination-search">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#ADADAD" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M17.5003 17.5001L13.917 13.9167" stroke="#ADADAD" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <input
                                        type="text"
                                        value={searchValue}
                                        onChange={this.updateSearch}
                                        placeholder={t('Ölkə axtar')}
                                    />
                                </div>

                                <div className="dashboard-esim-destination-tabs" role="tablist" aria-label="eSIM tabs">
                                    {this.tabs.map((tab) => (
                                        <button
                                            key={tab.key}
                                            type="button"
                                            className={`dashboard-esim-destination-tab ${activeTab === tab.key ? 'dashboard-esim-destination-tab__active' : ''}`}
                                            onClick={() => this.setActiveTab(tab.key)}
                                        >
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="dashboard-esim-destination-section">
                                <h4 className="dashboard-esim-destination-section-title">{t('Populyar ölkələr')}</h4>
                                <div className="dashboard-esim-destination-popular-grid">
                                    {popularCountries.map((country) => (
                                        <button
                                            className="dashboard-esim-destination-popular-card"
                                            type="button"
                                            key={`${country.id}-${country.name}`}
                                            onClick={() => this.openCountryDetails(country)}
                                        >
                                            <span className="dashboard-esim-destination-popular-card-flag">
                                                {country.flag && String(country.flag).indexOf('http') === 0
                                                    ? <img src={country.flag} alt={country.name} width="36" height="28" />
                                                    : country.flag}
                                            </span>
                                            <span className="dashboard-esim-destination-popular-card-name">{country.name}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {activeTab === 'COUNTRY' && (
                                <div className="dashboard-esim-destination-section">
                                    <h4 className="dashboard-esim-destination-section-title">{t('Ölkələr')}</h4>
                                    <div className="dashboard-esim-destination-countries-grid">
                                        {filteredCountries.map((country) => (
                                            <button
                                                className="dashboard-esim-destination-list-card"
                                                type="button"
                                                key={country.id}
                                                onClick={() => this.openCountryDetails(country)}
                                            >
                                                <div className="dashboard-esim-destination-list-card-left">
                                                    {/* <span className="dashboard-esim-destination-list-card-icon"> */}
                                                    {country.flag && String(country.flag).indexOf('http') === 0
                                                        ? <img src={country.flag} alt={country.name} width="36" height="28" />
                                                        : country.flag}
                                                    {/* </span> */}
                                                    <div>
                                                        <p className="dashboard-esim-destination-list-card-title">{country.name}</p>
                                                        <p className="dashboard-esim-destination-list-card-subtitle">{t('From')} {country.price}</p>
                                                    </div>
                                                </div>
                                                <span className="dashboard-esim-destination-list-card-arrow">{this.renderChevron()}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'REGION' && (
                                <div className="dashboard-esim-destination-section">
                                    <h4 className="dashboard-esim-destination-section-title">{t('Regional paketlər')}</h4>
                                    <div className="dashboard-esim-destination-regional-grid">
                                        {filteredRegionalPackages.map((item) => (
                                            <button className="dashboard-esim-destination-list-card" type="button" key={item.id} onClick={() => this.openCountryDetails(item.code || item.name)}>
                                                <div className="dashboard-esim-destination-list-card-left">
                                                    <span className="dashboard-esim-destination-list-card-icon">
                                                        {item.icon && String(item.icon).indexOf('http') === 0
                                                            ? <img src={item.icon} alt={item.name} width="36" height="28" />
                                                            : item.icon}
                                                    </span>
                                                    <div>
                                                        <p className="dashboard-esim-destination-list-card-title">{item.name}</p>
                                                        <p className="dashboard-esim-destination-list-card-subtitle">{item.countriesCount} • {item.price}</p>
                                                    </div>
                                                </div>
                                                <span className="dashboard-esim-destination-list-card-arrow">{this.renderChevron()}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'GLOBAL' && (
                                <div className="dashboard-esim-destination-section">
                                    <h4 className="dashboard-esim-destination-section-title">{t('Global paket')}</h4>
                                    <div className="dashboard-esim-destination-global-grid">
                                        {filteredGlobalPackages.map((item) => (
                                            <button className="dashboard-esim-destination-list-card" type="button" key={item.id} onClick={() => this.openCountryDetails(item.code || item.name)}>
                                                <div className="dashboard-esim-destination-list-card-left">
                                                    <span className="dashboard-esim-destination-list-card-icon">
                                                        {item.icon && String(item.icon).indexOf('http') === 0
                                                            ? <img src={item.icon} alt={item.name} width="36" height="28" />
                                                            : item.icon}
                                                    </span>
                                                    <div>
                                                        <p className="dashboard-esim-destination-list-card-title">{item.name}</p>
                                                        <p className="dashboard-esim-destination-list-card-subtitle">{item.countriesCount} • {item.price}</p>
                                                    </div>
                                                </div>
                                                <span className="dashboard-esim-destination-list-card-arrow">{this.renderChevron()}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>

        )
    }
}
export default translate("translation")(ESIM);